var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"registration-img"},[_c('RegistrationBg',{staticClass:"registration-img__item"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"registration-img__logo"},[_c('img',{attrs:{"width":"341","height":"77","src":"/img/registration-group/registrationLogo.svg","alt":"logo"}})])
}]

export { render, staticRenderFns }